import { LogLevel, Configuration, BrowserCacheLocation } from '@azure/msal-browser';

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;
 
export const b2cPolicies = {
     names: {
         signUpSignIn: "b2c_1_susi_reset_v2",
         editProfile: "b2c_1_edit_profile_v2"
     },
     authorities: {
         signUpSignIn: {
             authority: "https://login.microsoftonline.com/da688131-c2d2-46de-8a7f-6d130551ed54",
         },
         editProfile: {
             authority: "https://login.microsoftonline.com/da688131-c2d2-46de-8a7f-6d130551ed54"
         }
     },
     authorityDomain: "https://teaditbr.onmicrosoft.com"
 };
 
 
export const msalConfig: Configuration = {
     auth: {
         clientId: 'be71e1ce-d132-4110-b87a-da35a930e468',
         authority: b2cPolicies.authorities.signUpSignIn.authority,
         knownAuthorities: [b2cPolicies.authorityDomain],
         redirectUri: '/', 
     },
     cache: {
         cacheLocation: BrowserCacheLocation.LocalStorage,
         storeAuthStateInCookie: isIE, 
     },
     system: {
         loggerOptions: {
            loggerCallback: (logLevel, message, containsPii) => {
                console.log(message);
             },
             logLevel: LogLevel.Verbose,
             piiLoggingEnabled: false
         }
     }
 }

export const protectedResources = {
  todoListApi: {
    endpoint: "https://login.microsoftonline.com/da688131-c2d2-46de-8a7f-6d130551ed54",
    scopes: [
        "https://teaditbr.onmicrosoft.com/webapiteadit/user_impersonation"
    ],
  },
}
export const loginRequest = {
  scopes: []
};